<template>

  <div class="group" :ref="refs[builder.hingedHeights.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.hingedHeights.fieldName}Title`">
      <div class="group-title">Choose your arrangement.</div>
    </div>

    <Selector
      :key=builder.hingedHeights.fieldName
      :field-name=builder.hingedHeights.fieldName
      :display-type=builder.hingedHeights.displayType
      :options=builder.hingedHeights.options
      :selected=builder.currentItem.specs[builder.hingedHeights.fieldName]
      options-source="hingedHeightsOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.tops.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.tops.fieldName}Title`">
      <div class="group-title">What kind of wardrobe top would you like?</div>
      <div class="group-help">Not sure? <a href="/support/faqs/" target="_blank">Read our FAQs</a></div>
    </div>

    <Selector
      :key=builder.tops.fieldName
      :field-name=builder.tops.fieldName
      :display-type=builder.hingedHeights.displayType
      :options=builder.tops.options
      :selected=builder.currentItem.specs[builder.tops.fieldName]
      options-source="hingedTopsOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <!-- <div class="group" :ref="refs[builder.tops.fieldName + 'Group']" :class="{'s_hidden' : !builder.showTopFillMessage}">

    <div class="group-header l_text-center" style="justify-content: center;" :id="`${builder.tops.fieldName}Title`">
      <div class="group-title">Due to your ceiling height, a pelmet is automatically included.<br /><span>Please build a bulkhead to meet our 2750mm height limit. <br /><a href="https://mydiywardrobes.com.au/support/faqs/" target="_blank">Further details on our FAQ page</a></span></div>
    </div>

  </div> -->
  
  <div class="group" :ref="refs['widthGroup']" data-id="widthGroup">

    <div class="group-header">
      <div class="group-title">What are the measurements of the wardrobe?</div>
      <div class="group-help">Not sure? <a href="/support/how-to-measure/" target="_blank">See how to measure.</a></div>
    </div>

    <div class="group-inputs">

      <div class="group-input l_height" :ref="refs['heightGroup']" v-if="builder.showHingedHeight">

        <Input
        key="height"
        field-label="Ceiling Height"
        field-name="height"
        field-type="number"
        :init-value=builder.currentItem.specs.height
        :init-focus="false"
        :max=builder.currentProductStructure.height.max
        :min=builder.currentProductStructure.height.min
        :required="true"
        scope="specs"
        @update-value="updateValue"
        @update-non-standard="updateNonStandard"
        ></Input>

      </div>

      <div class="group-input l_x l_shrink" v-if="builder.showHingedHeight">
        <svg class="icon"><use href="#cross"></use></svg>
      </div>

      <div class="group-input" :ref="refs['widthGroup']">

        <Input
        key="width"
        field-label="Width"
        field-name="width"
        field-type="number"
        :init-value=builder.currentItem.specs.width
        :init-focus="false"
        :max=builder.currentProductStructure.width.max
        :min=builder.currentProductStructure.width.min
        :required="true"
        scope="specs"
        @update-value="updateValue"
        @update-non-standard="updateNonStandard"
        ></Input>

      </div>

    </div>
    
    <div class="group-footer l_text-center">            

      <div class="styledcheckbox group-checkbox">
        <input
          type="checkbox"
          name="levelsOut"
          id="levelsOut"
          value="1"
          :true-value="true"
          :false-value="false"
          v-model="builder.currentItem.specs.levelsOut" />
        <label for="levelsOut">
          <span class="checkbox-value">My levels are out more than 8mm</span>
        </label>
      </div>
      
    </div>
  
    <div class="group-footer l_text-center">
      
      <p>Overall Depth:&nbsp;&nbsp;600mm</p>
      
      <small>To maintain an economical product all internal board is 442mm and the overall depth is 600mm.</small>
    
    </div>
  
    <div class="group-footer l_text-center" v-if="isNonStandard">
      
      <p><strong>You've given us a size that's non-standard.</strong><br />Please <a href="https://packers.com.au/request-a-quote/" target="_blank" class="l_inherit-color">request a quote</a> and a Packers wardrobe designer will be in&nbsp;contact.</p>
      
      <a href="https://packers.com.au/request-a-quote/" target="_blank" class="btn">Request a quote from&nbsp;Packers</a>
    </div>
    
  </div>

  <div class="group" :ref="refs[builder.corniceHeights.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.corniceHeights.fieldName}Title`">
      <div class="group-title">Choose your cornice height.</div>
    </div>

    <Selector
      :key=builder.corniceHeights.fieldName
      :field-name=builder.corniceHeights.fieldName
      :display-type=builder.corniceHeights.displayType
      :options=builder.corniceHeights.options
      :selected=builder.currentItem.specs[builder.corniceHeights.fieldName]
      options-source="corniceHeightsOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>
  
</template>

<script setup>
  
import { computed, ref } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const nonStandard = ref({
  width: false,
  height: false
});

function updateValue(prop, val) {
  builder.setCurrentItemSpec(prop, val);
}

function updateNonStandard(prop, val) {
  nonStandard.value[prop] = val;
}

const isNonStandard = computed(() => {
  if (nonStandard.value.width || nonStandard.value.height) return true;
  return false;
})

function select(prop, opt) {
  builder.setCurrentItemSpec(prop, opt['id']);
  console.log(prop, opt['title']);
  if (prop == 'heightId') {
    if (opt['title'].indexOf('Standard') !== -1) builder.setCurrentItemSpec('height', 2300);
    else builder.setCurrentItemSpec('height', null);
  }
}

// init refs
let refHandles = [
  'widthGroup',
  builder.hingedHeights.fieldName + 'Group',
  builder.tops.fieldName + 'Group',
  builder.corniceHeights.fieldName + 'Group'
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>